class BannerSource {
    constructor(API) {
        this.API = API;
    }

    async list(banner_id) {
        return await this.API.get('/index.php?route=api/banner', {
            params: {
                banner_id: banner_id
            }
        })
    }
}


export default BannerSource
